import { getMembersSettingZendeskUrls } from "@/constants/zendesk-urls/members-zendesk-urls";
import { MemberEligibility } from "@/server/models/member/member-eligibility";
import { membersZendeskSsoLink } from "@/server/models/zendesk/zendesk-sso-link";

const wrapUrls = (urls: {
  changeName: string;
  changeAddress: string;
  manageDependents?: string;
  deleteAccount: string;
}) => ({
  changeName: membersZendeskSsoLink(urls.changeName),
  changeAddress: membersZendeskSsoLink(urls.changeAddress),
  manageDependents: urls.manageDependents
    ? membersZendeskSsoLink(urls.manageDependents)
    : undefined,
  deleteAccount: membersZendeskSsoLink(urls.deleteAccount),
});

export const getAccountSettingExternalUrls = ({
  isPrimary,
  eligibility,
}: {
  isPrimary: boolean;
  eligibility: MemberEligibility;
}) => {
  const urls = getMembersSettingZendeskUrls();
  if (eligibility === "lost_eligibility") {
    return wrapUrls(urls.lostEligibility);
  }

  if (!isPrimary) {
    return wrapUrls(urls.dependent);
  }

  switch (eligibility) {
    case "insured":
      return wrapUrls(urls.insured);
    case "optional_and_continued":
      return wrapUrls(urls.optionalAndContinued);
  }
};
